module.exports = __webpack_public_path__ + "img/369-661a8f.png";